var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"8"}},[_c('del-person-form',{attrs:{"delagatedPerson":_vm.delagatedPerson},on:{"emitData":_vm.updateDelagatedPerson}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }